import {useQuery, gql} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";

const QUERY = gql`
query getCompanyDetails($locale: String!){
 companyDetailsCollection(limit: 1, locale: $locale){
    items{
          naming
          contactDetails {
                streetPostalCodeCityCountry
                companyName
                eMail
                serviceNumber
                phone
                fax
                commercialRegister
                vatNumber
                companyNumber
          }
          cob{
                firstAndLastName
                 role
          }
          ceo{
                firstAndLastName
                role
          }
          coCeosCollection {
            items {
              firstAndLastName
            }
          }
          boardOfDirectorsCollection {
                items {
                  firstAndLastName
                  role
                }
          }
          executiveCommitteeCollection {
                items {
                  firstAndLastName
                  role
                }
          }
          ombudsman {
                  companyName
                  streetPostalCodeCityCountry
                  eMail
                  phone
          }
          extrajudicialDisputeResolution {
                json
          }
          informationDisputeResolution {
             json
          }

          languageSelectionCollection {
            items {
              name
              locale
            }
          }
          copyRight
          followUsCollection {
            items {
              name
              url
              iconPng {
                url
              }
            }
          }
          currentBookingPeriod
          bookingPeriod
          bookingOpeningTime
          datePickerCta{
            url
            label
          }
          bookingInformationCollection{
            items{
                ...on PdfDocument{
                    pdfDocumentCollection{
                        items{
                            url
                        }
                    }
                }
            }
        }
    }
  }
}
`;

export const useCompanyDetails = () => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY, { variables: { locale: localeUppercase}, errorPolicy: "all"});
    const companyDetails = data?.companyDetailsCollection.items[0];

    if (error?.message) {
        logger(error?.message, "error", "useCompanyDetails", error?.stack);
    }

    return {
        companyDetails,
        loading,
        error
    };
};
